import React, {FC} from 'react';
import './style.scss';

const RegisterButton: FC = () => {
  return (
    <div>
      <a href={`https://xiangjifanyi.com/console/workspace`} className="large-cta">
        开始使用
      </a>
    </div>
  );
};
export default RegisterButton;
